import { render } from "./PlayRecords.vue?vue&type=template&id=4445e520&scoped=true"
import script from "./PlayRecords.vue?vue&type=script&lang=js"
export * from "./PlayRecords.vue?vue&type=script&lang=js"

import "./PlayRecords.vue?vue&type=style&index=0&id=4445e520&scoped=true&lang=css"

import exportComponent from "C:\\Users\\javon\\mgs\\RabbitsfootOperatorApps\\playerpanel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4445e520"]])

export default __exports__